import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Suspense as _Suspense, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { key: 2 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "アクセスコード作成", -1)
const _hoisted_4 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_ManagementStripe = _resolveComponent("ManagementStripe")!
  const _component_ManagementCourse = _resolveComponent("ManagementCourse")!
  const _component_ManagementAccessCode = _resolveComponent("ManagementAccessCode")!
  const _component_ManagementUser = _resolveComponent("ManagementUser")!
  const _component_ManagementVideoUpload = _resolveComponent("ManagementVideoUpload")!
  const _component_ManagementVideoEdit = _resolveComponent("ManagementVideoEdit")!

  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.$style.parent
  }, [
    _createElementVNode("div", null, [
      (_ctx.state.display === 'planAndCourse')
        ? (_openBlock(), _createBlock(_component_el_row, {
            key: 0,
            class: _normalizeClass(_ctx.$style.plan_or_video)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 12,
                class: _normalizeClass(_ctx.$style.enable),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectChange('planAndCourse')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("プラン・コース編集")
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(_component_el_col, {
                class: _normalizeClass(_ctx.$style.disable),
                span: 12,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectChange('video')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("動画投稿・動画編集画面")
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _: 1
          }, 8, ["class"]))
        : _createCommentVNode("", true),
      (_ctx.state.display === 'video')
        ? (_openBlock(), _createBlock(_component_el_row, {
            key: 1,
            class: _normalizeClass(_ctx.$style.plan_or_video)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 12,
                class: _normalizeClass(_ctx.$style.disable),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectChange('planAndCourse')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("プラン・コース編集")
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(_component_el_col, {
                class: _normalizeClass(_ctx.$style.enable),
                span: 12,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectChange('video')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("動画投稿・動画編集画面")
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _: 1
          }, 8, ["class"]))
        : _createCommentVNode("", true),
      (_ctx.state.display === 'planAndCourse')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(), _createBlock(_Suspense, null, {
              default: _withCtx(() => [
                _createVNode(_component_ManagementStripe, {
                  onRefresh: _ctx.refresh,
                  ref: "ManagementStripeRef"
                }, null, 8, ["onRefresh"])
              ]),
              _: 1
            })),
            (_openBlock(), _createBlock(_Suspense, null, {
              default: _withCtx(() => [
                _createVNode(_component_ManagementCourse, {
                  onRefresh: _ctx.refresh,
                  ref: "ManagementCourseRef"
                }, null, 8, ["onRefresh"])
              ]),
              _: 1
            })),
            _hoisted_3,
            (_openBlock(), _createBlock(_Suspense, null, {
              default: _withCtx(() => [
                _createVNode(_component_ManagementAccessCode, {
                  onRefresh: _ctx.refresh,
                  ref: "ManagementAccessCodeRef"
                }, null, 8, ["onRefresh"])
              ]),
              _: 1
            })),
            (_openBlock(), _createBlock(_Suspense, null, {
              default: _withCtx(() => [
                _createVNode(_component_ManagementUser, {
                  onRefresh: _ctx.refresh,
                  ref: "ManagementUserRef"
                }, null, 8, ["onRefresh"])
              ]),
              _: 1
            }))
          ]))
        : _createCommentVNode("", true),
      (_ctx.state.display === 'video')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(), _createBlock(_Suspense, null, {
              default: _withCtx(() => [
                _createVNode(_component_ManagementVideoUpload, {
                  onRefresh: _ctx.refresh,
                  ref: "ManagementVideoUploadRef"
                }, null, 8, ["onRefresh"])
              ]),
              _: 1
            })),
            (_openBlock(), _createBlock(_Suspense, null, {
              default: _withCtx(() => [
                _createVNode(_component_ManagementVideoEdit, {
                  onRefresh: _ctx.refresh,
                  ref: "ManagementVideoEditRef"
                }, null, 8, ["onRefresh"])
              ]),
              _: 1
            }))
          ]))
        : _createCommentVNode("", true)
    ])
  ], 8, _hoisted_1))
}